__turbopack_context__.v({
  "headline": "BlockDonationForm-module-scss-module__pGWaxG__headline",
  "icon": "BlockDonationForm-module-scss-module__pGWaxG__icon",
  "richText": "BlockDonationForm-module-scss-module__pGWaxG__richText",
  "root": "BlockDonationForm-module-scss-module__pGWaxG__root",
});
